/**
 * @file This file contains the sequences for all tutorials in the game.
 * @module tutorialsConfig
 */

export const tutorialsConfig = {
    'first-game-tutorial': {
        id: 'first-game-tutorial',
        name: 'First Game Tutorial',
        condition: 'isFirstPlay', // This tutorial only runs if PlayerStatsManager.isFirstPlay() is true
        steps: [
            {
                type: 'banner',
                content: 'Welcome to Merge Village!',
                duration: 2500,
            },
            {
                type: 'tooltip',
                tooltipId: 'place-first-item',
                target: '#gem-queue',
                highlight: true,
                arrow: 'right',
                highlightBox: '#game-grid' // Highlight the grid with a border
            },
            // The next step is triggered by the 'place-first-item' tooltip's dismiss action.
            {
                type: 'tooltip',
                tooltipId: 'first-merge',
                target: '#game-grid',
                highlight: true,
                arrow: 'bottom',
                highlightBox: '#game-grid'
            }
        ]
    }
};